export default "__VITE_ASSET__6c195409__"